(function (scope) {
  'use strict';
  const integer = value => Number.isSafeInteger(Number(value)) && Number(value) >= 0 ? Number(value) : null;
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const parse = node => { try { return JSON.parse(node?.textContent || 'null'); } catch (_) { return null; } };
  const text = (config,key,values={}) => String(config?.copy?.[key] || '').replace(/\{(\w+)\}/g,(all,key)=>values[key] ?? all);
  function extraAllowed(config) {
    return config?.enabled === true && config.extraMode === 'synced' && config.sourceReady === true && Array.isArray(config.tiers) && config.tiers.length > 0;
  }
  function project(config, quantity, value) {
    const count=integer(quantity),cents=integer(value),policy=scope.SissiluxDiscounts?.policy;
    if(!extraAllowed(config)||count===null||cents===null||!policy)return null;
    const tier=config.tiers.filter(t=>count>=t.minimum_quantity).reduce((a,b)=>!a||b.percent>a.percent?b:a,null);
    const percent=tier?.percent||0,total=policy.price(cents,percent);
    return {quantity:count,percent,saving:cents-total,total};
  }
  function getConfig(context) {
    const raw=parse(context?.querySelector('[data-campaign-presentation]'));if(!raw)return null;
    const policy=scope.SissiluxDiscounts?.policy,tiers=policy?(raw.productId?policy.forProduct(raw.productId):policy.tiers()):[];
    const one=tiers.filter(t=>t.minimum_quantity<=1).reduce((a,b)=>!a||b.percent>a.percent?b:a,null);
    const many=tiers.filter(t=>t.minimum_quantity>1).sort((a,b)=>a.minimum_quantity-b.minimum_quantity||b.percent-a.percent)[0];
    return {...raw,sourceReady:policy?.live()===true,tiers,onePercent:one?.percent||0,manyPercent:many?.percent||one?.percent||0,manyMinimum:many?.minimum_quantity||2};
  }
  function cartQuote(config) {
    if(!extraAllowed(config))return null;
    const shared=scope.SissiluxDiscounts,policy=shared?.policy;
    const cart=shared?.cart||parse(scope.document?.querySelector('[data-siss-cart-snapshot],[data-sissilux-cart]'));
    if(!cart||cart.currency!==config.currency||!Array.isArray(cart.items))return null;
    let saving=0,original=0,total=0,quantity=0;const rates=new Set();
    for(const item of cart.items){
      const tier=policy.best(cart.items,item.product_id);if(!tier||!policy.eligible(tier,item))continue;
      const base=integer(item.original_line_price),final=integer(item.final_line_price);if(base===null||final===null)continue;
      const allAllocations=item.line_level_discount_allocations||item.discount_allocations;
      const allocations=(allAllocations||[]).filter(a=>{
        const app=a.discount_application;if(!app||app.value_type!=='percentage'||Number(app.value)!==tier.percent)return false;
        const titleMatches=typeof tier.title==='string'&&app.title===tier.title;
        return app.type==='automatic'?(!tier.title||titleMatches):!app.type&&titleMatches;
      });
      const applied=allocations.reduce((sum,a)=>sum+(integer(a.amount)||0),0);
      original+=base;total+=final;quantity+=Number(item.quantity)||0;
      if(applied>0){saving+=applied;rates.add(tier.percent);}
    }
    return saving>0?{quantity,original,total,saving,percent:rates.size===1?[...rates][0]:null,actual:true}:null;
  }
  function flags(config) {
    return '<span class="siss-regional-flags" aria-hidden="true">'+(config?.countryCodes||[]).filter(c=>/^[A-Z]{2}$/.test(c)).slice(0,4).map(c=>'<img src="https://cdn.shopify.com/static/images/flags/'+c.toLowerCase()+'.svg?width=40" width="20" height="15" alt="" loading="lazy">').join('')+'</span>';
  }
  function regionMarkup(config) { return flags(config)+'<span>'+esc(config.region)+'</span>'; }
  function money(config,program,cents) {
    try{return new Intl.NumberFormat(program?.locale||config.locale||'en',{style:'currency',currency:program?.currency||config.currency}).format(cents/100);}catch(_){return '';}
  }
  function rewardLabel(config,program,result,rules) {
    if(!result||!rules?.choiceCopy)return '';
    const gift=result.choiceLimit>1?'1 standard + 1 premium gift':result.minQuantity>=2?'a premium gift choice':'1 FREE gift';
    return gift+(result.giftCardValueCents>0?' + '+text(config,'giftCard',{amount:money(config,program,result.giftCardValueCents)}):'');
  }
  function cartMessage(config,program,rules) {
    if(!rules?.evaluate||!rules?.choiceCopy)return '';
    const count=integer(program.eligibleQuantity)||0;
    const next=(program.tiers||[]).filter(t=>t.enabled===true&&t.minQuantity>count).sort((a,b)=>a.minQuantity-b.minQuantity)[0];
    if(!count||!next)return '';
    const result=rules.evaluate(program,next.minQuantity),quote=project(config,next.minQuantity,0);
    if(!result||!quote)return '';
    const gap=next.minQuantity-count;
    return text(config,count<config.manyMinimum?'upgrade':'moreGifts',{quantity:gap,item:gap===1?'device':'devices',percent:quote.percent,rewards:rewardLabel(config,program,result,rules)});
  }
  // Existing homepage consumers may use this alias; it now accepts only synced rules.
  const api={extraAllowed,previewAllowed:extraAllowed,project,getConfig,cartQuote,flags,regionMarkup,cartMessage};
  if(typeof module!=='undefined'&&module.exports)module.exports=api;
  if(!scope.document)return;
  scope.SissiluxCampaignPresentation=api;
  if(scope.customElements.get('siss-promotion-layers'))return;
  class CampaignOffer extends scope.HTMLElement {
    static get observedAttributes(){return ['data-added-quantity','data-added-value'];}
    connectedCallback(){
      this.disconnectedCallback();this.config=getConfig(this);
      if(!this.config)return;
      this.refresh=()=>{if(this.frame)return;this.frame=scope.requestAnimationFrame(()=>{this.frame=0;if(this.isConnected)this.render();});};
      this.fitHost=this.dataset.surface==='pdp-benefit'?this.closest('sissilux-promotion-benefit'):this.dataset.surface==='cart-header'?this.closest('.siss-cart-offer-badge'):null;
      if(this.fitHost){
        if(scope.ResizeObserver){this.fitResize=new scope.ResizeObserver(()=>this.fitBadge());this.fitResize.observe(this.fitHost);}
        if(scope.MutationObserver){this.fitContent=new scope.MutationObserver(this.refresh);this.fitContent.observe(this.fitHost,{childList:true,subtree:true,characterData:true});}
        this.ownerDocument.fonts?.ready.then(()=>this.refresh?.());
      }
      for(const event of ['sissilux:promotion-updated','sissilux:discounts-updated','shopify:section:load'])this.ownerDocument.addEventListener(event,this.refresh);
      scope.addEventListener('pageshow',this.refresh);this.render();
    }
    disconnectedCallback(){
      if(this.refresh){for(const event of ['sissilux:promotion-updated','sissilux:discounts-updated','shopify:section:load'])this.ownerDocument.removeEventListener(event,this.refresh);scope.removeEventListener('pageshow',this.refresh);}
      if(this.frame)scope.cancelAnimationFrame(this.frame);this.frame=0;
      this.fitResize?.disconnect();this.fitContent?.disconnect();this.fitResize=null;this.fitContent=null;this.fitHost=null;
    }
    attributeChangedCallback(){this.refresh?.();}
    fitBadge(){
      const badge=this.dataset.surface==='pdp-benefit'?this.fitHost?.querySelector('.siss-promotion-benefit__topline>.siss-offer-region'):this.fitHost;
      if(!this.isConnected||!badge||badge.clientWidth<=0)return;
      const children=[...badge.children].filter(node=>!node.hidden&&scope.getComputedStyle(node).display!=='none');
      if(!children.length)return;
      // Measure full labels, rather than a flex-shrunk campaign label that clips.
      for(const child of children)child.style.flexShrink='0';
      const fits=size=>{
        badge.style.fontSize=size+'px';
        const css=scope.getComputedStyle(badge),gap=parseFloat(css.columnGap)||0;
        const used=children.reduce((sum,node)=>sum+node.getBoundingClientRect().width,0)+gap*Math.max(0,children.length-1)+(parseFloat(css.paddingLeft)||0)+(parseFloat(css.paddingRight)||0);
        return used<=badge.clientWidth+.25;
      };
      const maximum=scope.matchMedia?.('(max-width:749px)').matches?14:16;
      if(fits(maximum))return;
      let low=6,high=maximum;
      for(let i=0;i<7;i++){const middle=(low+high)/2;if(fits(middle))low=middle;else high=middle;}
      badge.style.fontSize=(Math.floor(low*4)/4)+'px';
    }
    readProgram(){
      if(this.dataset.surface==='cart-header')return parse(this.closest('cart-drawer')?.querySelector('[data-gpt-gift-state]'))?.promotion;
      const parent=this.closest('sissilux-home-bfcm,sissilux-promotion-intro,sissilux-promotion-benefit,[data-campaign-cart-page]');
      return scope.SissiluxPromotionRules?.readProgram(parent)||parse(parent?.querySelector('[data-siss-promotion-program]'));
    }
    render(){
      const program=this.readProgram(),config=this.config=getConfig(this);
      const active=program?.enabled===true&&program.contextCurrent!==false;
      const preview=active&&extraAllowed(config);
      const surface=this.dataset.surface;
      if(surface==='home'){
        this.hidden=true;
        const region=this.closest('sissilux-home-bfcm')?.querySelector('[data-campaign-overview-region]');
        if(region){region.hidden=!preview;if(preview)region.innerHTML=regionMarkup(config);}
        for(const badge of this.closest('sissilux-home-bfcm')?.querySelectorAll('[data-campaign-tier]')||[]){
          const quote=project(config,Number(badge.dataset.minimum),0);badge.hidden=!preview||!quote;
          const html=preview&&quote?'<strong>'+esc(text(config,'extra',{percent:quote.percent}))+'</strong>':'';
          if(badge.innerHTML!==html)badge.innerHTML=html;
        }
        return;
      }
      if(surface==='pdp'||surface==='pdp-benefit'){this.hidden=true;this.fitBadge();return;}
      this.hidden=surface==='cart-header'?!preview:!active;
      if(this.hidden&&surface!=='cart-header')return;
      const quote=cartQuote(config);
      const saving=this.querySelector('[data-campaign-cart-saving]');saving.hidden=!preview||!quote?.percent;
      if(!saving.hidden){const html=surface==='cart-header'?'<span class="siss-campaign__header-rate">'+flags(config)+'<span>'+esc(quote.percent)+'% OFF</span></span><span class="siss-campaign__header-amount">Save '+esc(money(config,program,quote.saving))+'</span>':flags(config)+'<span>'+esc(text(config,'cartSaving',{percent:quote.percent,amount:money(config,program,quote.saving)}))+'</span>';if(saving.innerHTML!==html)saving.innerHTML=html;}
      const rules=scope.SissiluxPromotionRules;
      if(surface==='cart-page')this.querySelector('[data-campaign-cart-rewards]').textContent=rewardLabel(config,program,rules?.evaluate?.(program,program.eligibleQuantity),rules);
      const rewards=this.closest('cart-drawer')?.querySelector('gpt-gift-milestones[data-promotion-rewards]');
      rewards?.toggleAttribute('data-campaign-extra-active',preview || (surface==='cart-header'&&active));
      const progress=surface==='cart-page'?this.querySelector('[data-campaign-cart-progress]'):rewards?.querySelector('[data-campaign-cart-progress]');
      if(progress){const message=surface==='cart-header'?(active&&Number(program.eligibleQuantity)===1?'Add 1 more for a premium gift.':''):(preview?cartMessage(config,program,rules):'');progress.hidden=!message;progress.innerHTML=message?(surface==='cart-header'?'':flags(config))+'<span>'+esc(message)+'</span>':'';}
      this.fitBadge();
    }
  }
  scope.customElements.define('siss-promotion-layers',CampaignOffer);
  scope.document.dispatchEvent(new scope.CustomEvent('sissilux:promotion-updated'));
})(typeof window!=='undefined'?window:globalThis);
